import { render, staticRenderFns } from "./DropShipStores.vue?vue&type=template&id=75587e84&scoped=true&"
import script from "./DropShipStores.vue?vue&type=script&lang=js&"
export * from "./DropShipStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75587e84",
  null
  
)

export default component.exports